import { useWatch } from 'react-hook-form';

import { useValueChanged } from '@sh4res/bo-common/hooks';
import {
  PEE_GRID_LENGTH,
  PERECO_GRID_LENGTH,
} from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';
import { useB2bInvestorProfileGridFormManagement } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/hooks/useB2bInvestorProfileGridFormManagement';

export const useB2bInvestorProfileGridLogic = () => {
  const [instruments, grid_template, product_category] = useWatch({
    name: ['instruments', 'grid_template', 'product_category'],
  });

  const { currentGrid, addInstrument, removeInstrument } =
    useB2bInvestorProfileGridFormManagement();

  useValueChanged({ instruments, product_category }, (value, prev) => {
    if (value?.instruments?.length < prev?.instruments?.length) {
      // Instrument removal
      const removedInstrumentId: number | undefined = prev?.instruments
        .filter((item: number) => value?.instruments?.indexOf(item) < 0)
        .at(0);

      if (removedInstrumentId !== undefined) {
        removeInstrument(removedInstrumentId);
      }
    } else if (value?.instruments?.length > prev?.instruments?.length) {
      // Instrument addition
      const addedInstrumentId: number | undefined = value?.instruments
        .filter((item: number) => prev?.instruments?.indexOf(item) < 0)
        .at(0);

      if (addedInstrumentId !== undefined) {
        addInstrument({
          instrument_id: addedInstrumentId,
          allocation: Array(
            product_category === 'PERECO' || product_category === 'PERECOG'
              ? PERECO_GRID_LENGTH
              : PEE_GRID_LENGTH,
          ).fill(0),
        });
      }
    }
  });

  return {
    currentGrid,
    grid_template,
    product_category,
  };
};
